/* eslint-disable jsx-a11y/anchor-is-valid */
/**
PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *  Copyright © 2021 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
* */

/**
 * QRCodeButton component
 *
 * @file QRCodeButton.jsx
 * @author Ujjwal Sana
 * @since 0.0.1
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from '@mui/material';
import { injectIntl } from 'react-intl';
import * as constants from '../../constants';
import QRCodeIcon from '../../icons/QRCodeIcon';
import {
  IconWithTextContainer,
  IconOnlyContainer,
  QrButtonContainer,
  IconTextContainer,
  QrBtnTitle,
  StyledTooltip,
  QrButtonContainerIconOnly,
  IconTextContainerIconOnly,
  QrBtnTitleOnlyIconOnly
} from './styles/QRCodeStyles';

const QRCodeButton = ({
  title, onQrCodeClick
}) => {
  const { QR_CODE_EVENT } = constants;
  const isTabletOrBelowResolution = !useMediaQuery('@media screen and (min-width: 1024px)');

  const buttonWithIcon = (
    <QrButtonContainerIconOnly>
      <IconTextContainerIconOnly>
        <QRCodeIcon />
        <QrBtnTitleOnlyIconOnly className="ereader-qrcode-cta-text">{title}</QrBtnTitleOnlyIconOnly>
      </IconTextContainerIconOnly>
    </QrButtonContainerIconOnly>
  );

  return (
    <div>
      {/* QR code CTA */}
      {!isTabletOrBelowResolution
        && (
          <IconWithTextContainer>
            <QrButtonContainer
              data-componentId={constants.COMPONENT_IDS.EREADER_QR_CODE_CTA}
              className="ereader-qrcode-cta"
              onClick={event => onQrCodeClick(QR_CODE_EVENT.EREADER_HEADER_FIELD, event)}
            >
              <IconTextContainer>
                <QRCodeIcon />
                <QrBtnTitle className="ereader-qrcode-cta-text">{title}</QrBtnTitle>
              </IconTextContainer>
            </QrButtonContainer>
          </IconWithTextContainer>
        )
      }

      {/* Only icon will be displayed in tablet and lower resolutions */}
      {isTabletOrBelowResolution
        && (
        <IconOnlyContainer>
          <StyledTooltip
            title={buttonWithIcon}
            arrow
          >
            <QrButtonContainer
              data-componentId={constants.COMPONENT_IDS.EREADER_QR_CODE_CTA}
              className="ereader-qrcode-cta"
              onClick={event => onQrCodeClick(QR_CODE_EVENT.EREADER_HEADER_FIELD, event)}
            >
              <IconTextContainer>
                <QRCodeIcon />
              </IconTextContainer>
            </QrButtonContainer>
          </StyledTooltip>
        </IconOnlyContainer>
        )}
    </div>
  );
};

QRCodeButton.propTypes = {
  title: PropTypes.string.isRequired,
  onQrCodeClick: PropTypes.func.isRequired
};

export default injectIntl(QRCodeButton);
